import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, LOGO_URL } from "@/lib/site";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-white/10 bg-brand-bg mt-24 z-10"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
                    <div className="md:col-span-5">
                        <div className="flex flex-col gap-3">
                            <img
                                src={LOGO_URL}
                                alt="LMJ International"
                                className="h-32 w-auto object-contain self-start drop-shadow-[0_4px_18px_rgba(0,85,164,0.45)]"
                            />
                            <div className="font-mono text-[10px] tracking-[0.2em] text-brand-blue uppercase">
                                NAVSEA · ABS · MIL-SPEC
                            </div>
                        </div>
                        <p className="mt-6 text-slate-400 max-w-md leading-relaxed">
                            Naval-grade welding and shipyard labor services.
                            Certified crews ready to mobilize to any U.S. shipyard.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-mono text-[11px] tracking-[0.2em] text-brand-blue uppercase mb-4">
                            Navigation
                        </div>
                        <ul className="space-y-2 font-display uppercase text-sm tracking-wider">
                            {[
                                ["/", "Home"],
                                ["/services", "Services"],
                                ["/photos", "Photos"],
                                ["/about", "About"],
                                ["/contact", "Contact"],
                            ].map(([to, label]) => (
                                <li key={to}>
                                    <Link
                                        to={to}
                                        data-testid={`footer-link-${label.toLowerCase()}`}
                                        className="text-slate-300 hover:text-white transition-colors"
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="font-mono text-[11px] tracking-[0.2em] text-brand-blue uppercase mb-4">
                            Contact
                        </div>
                        <ul className="space-y-3 text-sm text-slate-300">
                            <li>
                                <a
                                    href={`tel:${COMPANY.phoneTel}`}
                                    data-testid="footer-phone"
                                    className="flex items-start gap-3 hover:text-white transition-colors"
                                >
                                    <Phone className="h-4 w-4 text-brand-blue mt-0.5 shrink-0" />
                                    <span className="font-mono">
                                        {COMPANY.phone}
                                    </span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${COMPANY.email}`}
                                    data-testid="footer-email"
                                    className="flex items-start gap-3 hover:text-white transition-colors"
                                >
                                    <Mail className="h-4 w-4 text-brand-blue mt-0.5 shrink-0" />
                                    <span>{COMPANY.email}</span>
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin className="h-4 w-4 text-brand-blue mt-0.5 shrink-0" />
                                <span>
                                    {COMPANY.address.line1}
                                    <br />
                                    {COMPANY.address.line2}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/10 overflow-hidden">
                <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12">
                    <div className="font-display font-black text-white tracking-tighter leading-none text-[14vw] sm:text-[12vw] md:text-[10vw] uppercase select-none">
                        Precision Crafted
                    </div>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    <p className="font-mono text-xs text-slate-500">
                        © {new Date().getFullYear()} {COMPANY.name}. All rights
                        reserved.
                    </p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
                        Sheridan, Wyoming · United States
                    </p>
                </div>
            </div>
        </footer>
    );
}
